import React, { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import StudentCard from './StudentCard'

const ClassroomTeachersList = ({ myVisibleTeachersList, openStudent, t, dataVersion }) => {
    // Bind the shared comment tooltip to whatever cards are on screen now.
    useEffect(() => {
        ReactTooltip.rebuild()
    }, [myVisibleTeachersList])

    return (
        <>
            <div className="classroom-wellbeing-title classroom-section-enter">
                <p>{t('wellbeingOfTeachers')}</p>
            </div>
            {/* Keyed by the data version so the stagger replays only when new data arrives. */}
            <div className="classroom-wellbeing-row classroom-cards-animate classroom-section-enter mt-5" key={dataVersion}>
                {myVisibleTeachersList.map((item, index) => (
                    <StudentCard key={item?.user?.id ?? `teacher-${index}`} student={item} index={index} onSelect={openStudent} />
                ))}
            </div>
        </>
    )
}

export default React.memo(ClassroomTeachersList)
